<template>
  <el-dialog v-if="dialogVisibleStatistics" :append-to-body="true" :title="$tx('hygl.voteManage.votingResults','投票结果')" :visible.sync="dialogVisibleStatistics" width="850px" @close="dialogVisibleStatistics = false">
    <statistics :id="id" :type="type" :row="row" />
  </el-dialog>
</template>
<script>
import statistics from './statisticsVote'
export default {
    components: {
        statistics
    },
    props: {

    },
    data() {
        return {
            dialogVisibleStatistics: false,
            type: '',
            row: {}

        }
    },
    computed: {

    },
    created() {
        console.log(26)
        this.$bus.on('openstatistics', this.openStatistics)
    },
    beforeDestroy() {
        this.$bus.off('openstatistics', this.openStatistics)
    },
    mounted() {

    },
    methods: {
        openStatistics(row) {
            console.log(row)
            this.dialogVisibleStatistics = true
            this.row = row
            this.id = row.id
            this.type = ''
        }
    }
}
</script>

<style scoped lang="scss">

</style>
